export const ADD_ONLINESALES_DATA = 'ADD_ONLINESALES_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/onlinesales/action-types.js